/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaymentProvider } from './PaymentProvider';
import {
    PaymentProviderFromJSON,
    PaymentProviderFromJSONTyped,
    PaymentProviderToJSON,
    PaymentProviderToJSONTyped,
} from './PaymentProvider';
import type { PaymentMethodCategory } from './PaymentMethodCategory';
import {
    PaymentMethodCategoryFromJSON,
    PaymentMethodCategoryFromJSONTyped,
    PaymentMethodCategoryToJSON,
    PaymentMethodCategoryToJSONTyped,
} from './PaymentMethodCategory';
import type { PaymentMethodConfiguration } from './PaymentMethodConfiguration';
import {
    PaymentMethodConfigurationFromJSON,
    PaymentMethodConfigurationFromJSONTyped,
    PaymentMethodConfigurationToJSON,
    PaymentMethodConfigurationToJSONTyped,
} from './PaymentMethodConfiguration';
import type { PayoutSource } from './PayoutSource';
import {
    PayoutSourceFromJSON,
    PayoutSourceFromJSONTyped,
    PayoutSourceToJSON,
    PayoutSourceToJSONTyped,
} from './PayoutSource';

/**
 * 
 * @export
 * @interface PaymentMethodDetailsDto
 */
export interface PaymentMethodDetailsDto {
    /**
     * 
     * @type {PaymentMethodConfiguration}
     * @memberof PaymentMethodDetailsDto
     */
    _configuration: PaymentMethodConfiguration;
    /**
     * 
     * @type {Date}
     * @memberof PaymentMethodDetailsDto
     */
    created: Date;
    /**
     * 
     * @type {string}
     * @memberof PaymentMethodDetailsDto
     */
    createdByUserEmail: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentMethodDetailsDto
     */
    externalId: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentMethodDetailsDto
     */
    paymentMethod: string;
    /**
     * 
     * @type {PaymentMethodCategory}
     * @memberof PaymentMethodDetailsDto
     */
    paymentMethodCategory: PaymentMethodCategory;
    /**
     * 
     * @type {PaymentProvider}
     * @memberof PaymentMethodDetailsDto
     */
    paymentProvider: PaymentProvider;
    /**
     * 
     * @type {PayoutSource}
     * @memberof PaymentMethodDetailsDto
     */
    payoutSource: PayoutSource;
    /**
     * 
     * @type {Date}
     * @memberof PaymentMethodDetailsDto
     */
    updated: Date;
    /**
     * 
     * @type {string}
     * @memberof PaymentMethodDetailsDto
     */
    updatedByUserEmail: string;
}



/**
 * Check if a given object implements the PaymentMethodDetailsDto interface.
 */
export function instanceOfPaymentMethodDetailsDto(value: object): value is PaymentMethodDetailsDto {
    if ((!('_configuration' in (value as Record<string, any>)) && !('configuration' in (value as Record<string, any>))) || ((value as Record<string, any>)['_configuration'] === undefined && (value as Record<string, any>)['configuration'] === undefined)) return false;
    if (!('created' in value) || value['created'] === undefined) return false;
    if (!('createdByUserEmail' in value) || value['createdByUserEmail'] === undefined) return false;
    if (!('externalId' in value) || value['externalId'] === undefined) return false;
    if (!('paymentMethod' in value) || value['paymentMethod'] === undefined) return false;
    if (!('paymentMethodCategory' in value) || value['paymentMethodCategory'] === undefined) return false;
    if (!('paymentProvider' in value) || value['paymentProvider'] === undefined) return false;
    if (!('payoutSource' in value) || value['payoutSource'] === undefined) return false;
    if (!('updated' in value) || value['updated'] === undefined) return false;
    if (!('updatedByUserEmail' in value) || value['updatedByUserEmail'] === undefined) return false;
    return true;
}

export function PaymentMethodDetailsDtoFromJSON(json: any): PaymentMethodDetailsDto {
    return PaymentMethodDetailsDtoFromJSONTyped(json, false);
}

export function PaymentMethodDetailsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentMethodDetailsDto {
    if (json == null) {
        return json;
    }
    return {
        
        '_configuration': PaymentMethodConfigurationFromJSON(json['configuration']),
        'created': (new Date(json['created'])),
        'createdByUserEmail': json['createdByUserEmail'],
        'externalId': json['externalId'],
        'paymentMethod': json['paymentMethod'],
        'paymentMethodCategory': PaymentMethodCategoryFromJSON(json['paymentMethodCategory']),
        'paymentProvider': PaymentProviderFromJSON(json['paymentProvider']),
        'payoutSource': PayoutSourceFromJSON(json['payoutSource']),
        'updated': (new Date(json['updated'])),
        'updatedByUserEmail': json['updatedByUserEmail'],
    };
}

export function PaymentMethodDetailsDtoToJSON(json: any): PaymentMethodDetailsDto {
    return PaymentMethodDetailsDtoToJSONTyped(json, false);
}

export function PaymentMethodDetailsDtoToJSONTyped(value?: PaymentMethodDetailsDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'configuration': PaymentMethodConfigurationToJSON(value['_configuration']),
        'created': value['created'].toISOString(),
        'createdByUserEmail': value['createdByUserEmail'],
        'externalId': value['externalId'],
        'paymentMethod': value['paymentMethod'],
        'paymentMethodCategory': PaymentMethodCategoryToJSON(value['paymentMethodCategory']),
        'paymentProvider': PaymentProviderToJSON(value['paymentProvider']),
        'payoutSource': PayoutSourceToJSON(value['payoutSource']),
        'updated': value['updated'].toISOString(),
        'updatedByUserEmail': value['updatedByUserEmail'],
    };
}

